(function () {
  'use strict';

  var yearEls = document.querySelectorAll('[data-current-year]');
  for (var i = 0; i < yearEls.length; i += 1) {
    yearEls[i].textContent = new Date().getFullYear();
  }

  var popupEl = document.querySelector('.Popup');
  var closeBtn = document.querySelector('.CloseButton');

  if (popupEl) {
    setTimeout(function () {
      popupEl.classList.add('slide-up');
    }, 1000);
  }

  if (closeBtn && popupEl) {
    closeBtn.addEventListener('click', function () {
      popupEl.classList.remove('slide-up');
    });
  }

  var waitlistForms = document.querySelectorAll('[data-waitlist-form]');

  function setMessage(msg, text, state) {
    var isProductMessage = msg.classList.contains('product-notify-message');
    var isPopupMessage = msg.classList.contains('popup-msg');
    msg.className = 'msg';
    if (isProductMessage) {
      msg.classList.add('product-notify-message');
    }
    if (isPopupMessage) {
      msg.classList.add('popup-msg');
    }
    if (state) {
      msg.classList.add(state);
    }
    msg.textContent = text;
  }

  function stripTags(value) {
    var temp = document.createElement('div');
    temp.innerHTML = value || '';
    return temp.textContent || temp.innerText || '';
  }

  function getMailchimpJsonpUrl(currentForm, callbackName) {
    var action = currentForm.getAttribute('action') || '';
    var jsonpAction = action.replace('/subscribe/post?', '/subscribe/post-json?');
    var url = new URL(jsonpAction, window.location.href);
    var formData = new FormData(currentForm);

    formData.forEach(function (value, key) {
      url.searchParams.set(key, value);
    });
    url.searchParams.set('c', callbackName);

    return url.toString();
  }

  function submitMailchimp(currentForm, msg, input, button) {
    var callbackName = 'nvrMailchimpCallback' + Date.now() + Math.floor(Math.random() * 1000);
    var script = document.createElement('script');
    var timeoutId;

    function cleanup() {
      if (timeoutId) {
        window.clearTimeout(timeoutId);
      }
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
      try {
        delete window[callbackName];
      } catch (_) {
        window[callbackName] = undefined;
      }
      if (button) {
        button.disabled = false;
      }
    }

    if (button) {
      button.disabled = true;
    }

    window[callbackName] = function (response) {
      var result = response && response.result;
      var responseMessage = stripTags(response && response.msg);
      cleanup();

      if (result === 'success') {
        setMessage(msg, "you're on the list.", 'ok');
        input.value = '';
        return;
      }

      if (/already subscribed/i.test(responseMessage)) {
        setMessage(msg, "you're already on the list.", 'ok');
        input.value = '';
        return;
      }

      setMessage(msg, responseMessage || 'something went wrong. please try again.', 'err');
    };

    script.onerror = function () {
      cleanup();
      setMessage(msg, 'something went wrong. please try again.', 'err');
    };

    timeoutId = window.setTimeout(function () {
      cleanup();
      setMessage(msg, 'something went wrong. please try again.', 'err');
    }, 10000);

    script.src = getMailchimpJsonpUrl(currentForm, callbackName);
    document.body.appendChild(script);
  }

  for (var formIndex = 0; formIndex < waitlistForms.length; formIndex += 1) {
    var form = waitlistForms[formIndex];
    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var currentForm = e.currentTarget;
      var msg = currentForm.querySelector('[data-waitlist-message]');
      var input = currentForm.querySelector('input[type="email"]');
      if (!msg || !input) return;

      var value = input.value.trim();
      var valid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
      var button = currentForm.querySelector('button[type="submit"], input[type="submit"]');

      if (!valid) {
        setMessage(msg, 'please enter a valid email.', 'err');
        return;
      }

      setMessage(msg, 'submitting...', '');
      submitMailchimp(currentForm, msg, input, button);
    });
  }

  var copyBtn = document.getElementById('copy');
  var emailLink = document.getElementById('email-link');
  if (copyBtn && emailLink) {
    copyBtn.addEventListener('click', function () {
      var email = 'info@nvrforever.com';
      var done = function () {
        copyBtn.classList.add('copied');
        var previous = copyBtn.textContent;
        copyBtn.textContent = 'copied';
        setTimeout(function () {
          copyBtn.classList.remove('copied');
          copyBtn.textContent = previous;
        }, 1600);
      };
      var fallback = function () {
        var range = document.createRange();
        range.selectNode(emailLink);
        var selection = window.getSelection();
        selection.removeAllRanges();
        selection.addRange(range);
        try {
          document.execCommand('copy');
        } catch (_) {
          // Clipboard feedback still works when the copy command is blocked.
        }
        selection.removeAllRanges();
        done();
      };

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(email).then(done, fallback);
      } else {
        fallback();
      }
    });
  }
})();
